import { QueryKey } from 'constants/reactQuery';

export const profileFollowQueryKey = {
  profileFollows: [QueryKey.Profile, QueryKey.Follow] as const,
  profileFollow: (id: number) => [...profileFollowQueryKey.profileFollows, id] as const,
};
